import * as React from 'react';
import { makeIcon } from './makeIcon';
const Minus = props => (React.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16" }, props),
    React.createElement("polygon", { points: "0 7 0 9 16 9 16 7" })));
export const MinusIcon = makeIcon('minus')(Minus);
//# sourceMappingURL=Minus.js.map